import React from 'react'

export default () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon/action/visibility_24px">
      <path
        id="icon/action/visibility_24px_2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.75 9C2.0475 5.7075 5.25 3.375 9 3.375C12.75 3.375 15.9525 5.7075 17.25 9C15.9525 12.2925 12.75 14.625 9 14.625C5.25 14.625 2.0475 12.2925 0.75 9ZM15.6151 9C14.3776 6.4725 11.8426 4.875 9.00008 4.875C6.15758 4.875 3.62258 6.4725 2.38508 9C3.62258 11.5275 6.15758 13.125 9.00008 13.125C11.8426 13.125 14.3776 11.5275 15.6151 9ZM9 7.125C10.035 7.125 10.875 7.965 10.875 9C10.875 10.035 10.035 10.875 9 10.875C7.965 10.875 7.125 10.035 7.125 9C7.125 7.965 7.965 7.125 9 7.125ZM5.625 9C5.625 7.14 7.14 5.625 9 5.625C10.86 5.625 12.375 7.14 12.375 9C12.375 10.86 10.86 12.375 9 12.375C7.14 12.375 5.625 10.86 5.625 9Z"
        fill="#C4C4C4"
      />
    </g>
  </svg>
)
